

// import { Loader } from '@progress/kendo-react-indicators'
import { usePostSurvey } from '../../../Hooks/usePostSurvey'
import { useGlobalCtx } from '../../../Context/GlobalContext'
import LoaderSpinner from '../../atoms/Loader/Loader'
import { RecruitConfirmation } from '../../molecules/Recruit/RecruitConfirmation'
import { ScheduleState, SelectedSession } from '../../../Common'
import { format } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { useSurveyCtx } from '../../../Context/SurveyContext'
import { DataService_Domain_Models_ErrorCodes, SurveyEngine_Models_Session, SurveyEngine_Models_StudyType, SurveyService_Models_PanelistSessionSchedule } from '../../../api'
import { useRecruitCtx } from '../../../Context/RecruitContext'
import { BasicSession } from '../../molecules/Recruit/BasicSession'
import { Cluster } from '../../molecules/Recruit/Cluster'
import SurveyError from '../Error/SurveyError'
import { useEffect } from 'react'
import { Timer } from '../../atoms/Timer/Timer'
import SurveyComplete from '../../molecules/SurveyComplete/surveyComplete'
import { Error } from '@progress/kendo-react-labels'
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TimeOut from '../Timeout/timeout'
import { Calendly } from '../../molecules/Recruit/Calendly'
import { languageResources } from '../../../Utils/messages'
// interface PostSurveyProps {
//   scheduledSessions?: any
//   availableSessions?: any
//   isLoading?: boolean | undefined
// }

export default function PostSurvey() {

  const globalCtx = useGlobalCtx();
  const surveytCtx = useSurveyCtx();
  const recruitCtx = useRecruitCtx();

  const { getRefreshToken, getPanelistAvailableSessions, getSubmitSchedule,getSubmitCalendarSchedule,getAbandonSurvey } = usePostSurvey(globalCtx.StudyId, globalCtx.PanelistId)

  useEffect(()=>{

    if(!surveytCtx.IsAPIError)
    {
      if(recruitCtx.currentState === ScheduleState.POST_SURVEY_RESCHEDULE
      || recruitCtx.currentState === ScheduleState.POST_SURVEY_CANCELLED
      || recruitCtx.currentState === ScheduleState.POST_SURVEY_COMPLETED_DIALOG)
      {
        getPanelistAvailableSessions(globalCtx.PanelistId, globalCtx.StudyId,recruitCtx.panelistOverAllStatus);
      }
    }
    window.scrollTo(0, 0)    

  },[getPanelistAvailableSessions, globalCtx.PanelistId, globalCtx.StudyId, recruitCtx.currentState,surveytCtx.IsAPIError,recruitCtx.panelistOverAllStatus])

  let component = <LoaderSpinner fullScreen={true}/>

  const showErrorPage = (type:SurveyEngine_Models_StudyType,error:DataService_Domain_Models_ErrorCodes) =>  {

    if(!type && !error)
    {
      return false;
    }
    if(type === SurveyEngine_Models_StudyType.CALENDAR)
    {
      return [
        DataService_Domain_Models_ErrorCodes.INVALID_INPUT,
        DataService_Domain_Models_ErrorCodes.STUDY_NOT_AVAILABLE,
        DataService_Domain_Models_ErrorCodes.INVALID_PANELIST_STATUS,
        DataService_Domain_Models_ErrorCodes.STUDY_QUOTA_IS_FULL,
        DataService_Domain_Models_ErrorCodes.CALENDAR_INTEGRATION_ERROR,
        DataService_Domain_Models_ErrorCodes.SURVEY_ENGINE_LEGACY_MODE_ON,
        DataService_Domain_Models_ErrorCodes.POST_SURVEY_SID_ACTIVE,
        DataService_Domain_Models_ErrorCodes.POST_SURVEY_INVALID_CURRENT_SCHEDULE,
        DataService_Domain_Models_ErrorCodes.POST_SURVEY_SESSIONS_RESCHEDULE_ERROR,
        DataService_Domain_Models_ErrorCodes.POST_SURVEY_SESSIONS_SCHEDULE_ERROR,
        DataService_Domain_Models_ErrorCodes.POST_SURVEY_STUDY_QUOTA_IS_FULL,
        DataService_Domain_Models_ErrorCodes.POST_SURVEY_DYNAMIC_QUOTA_ASSIGNMENT_FAILED,
        DataService_Domain_Models_ErrorCodes.POST_SURVEY_GATE_ASSIGNMENT_FAILED,
        DataService_Domain_Models_ErrorCodes.POST_SURVEY_NO_SESSIONS_AVAILABLE,
        DataService_Domain_Models_ErrorCodes.AUTHENTICATION_FAILURE,
        DataService_Domain_Models_ErrorCodes.AUTHORIZATION_FAILURE,
        DataService_Domain_Models_ErrorCodes.INTERNAL_ERROR
      ].includes(error);
  
    }
    else {
      return [
        DataService_Domain_Models_ErrorCodes.INVALID_INPUT,
        DataService_Domain_Models_ErrorCodes.STUDY_NOT_AVAILABLE,
        DataService_Domain_Models_ErrorCodes.INVALID_PANELIST_STATUS,
        DataService_Domain_Models_ErrorCodes.STUDY_QUOTA_IS_FULL,
        DataService_Domain_Models_ErrorCodes.SURVEY_ENGINE_LEGACY_MODE_ON,
        DataService_Domain_Models_ErrorCodes.POST_SURVEY_SID_ACTIVE,
        DataService_Domain_Models_ErrorCodes.POST_SURVEY_INVALID_CURRENT_SCHEDULE,
        DataService_Domain_Models_ErrorCodes.POST_SURVEY_STUDY_QUOTA_IS_FULL,
        DataService_Domain_Models_ErrorCodes.POST_SURVEY_DYNAMIC_QUOTA_ASSIGNMENT_FAILED,
        DataService_Domain_Models_ErrorCodes.POST_SURVEY_GATE_ASSIGNMENT_FAILED,
        DataService_Domain_Models_ErrorCodes.POST_SURVEY_NO_SESSIONS_AVAILABLE,
        DataService_Domain_Models_ErrorCodes.AUTHENTICATION_FAILURE,
        DataService_Domain_Models_ErrorCodes.AUTHORIZATION_FAILURE,
        DataService_Domain_Models_ErrorCodes.INTERNAL_ERROR
        ].includes(error);  
    }
    
  }

  if(surveytCtx.IsAPIError && showErrorPage(surveytCtx.currentPanelistSchedule.studyType!,surveytCtx.APIError.errorCode!))
  {
    let message=""
    switch(surveytCtx.APIError.errorCode)
    {
      case DataService_Domain_Models_ErrorCodes.INVALID_PANELIST_STATUS:
      case DataService_Domain_Models_ErrorCodes.STUDY_QUOTA_IS_FULL:
      case DataService_Domain_Models_ErrorCodes.STUDY_NOT_AVAILABLE: 
      case DataService_Domain_Models_ErrorCodes.POST_SURVEY_DYNAMIC_QUOTA_ASSIGNMENT_FAILED:  
      case DataService_Domain_Models_ErrorCodes.POST_SURVEY_INVALID_CURRENT_SCHEDULE:          
      case DataService_Domain_Models_ErrorCodes.POST_SURVEY_STUDY_QUOTA_IS_FULL:
      case DataService_Domain_Models_ErrorCodes.POST_SURVEY_DYNAMIC_QUOTA_ASSIGNMENT_FAILED:
      case DataService_Domain_Models_ErrorCodes.POST_SURVEY_GATE_ASSIGNMENT_FAILED:
        message = globalCtx.LangResources.errorMsg.studyNotAvalable??languageResources.en_US.errorMsg.studyNotAvalable;
        break;
      case DataService_Domain_Models_ErrorCodes.POST_SURVEY_NO_SESSIONS_AVAILABLE:
        message = globalCtx.LangResources.errorMsg.noScheduleAvailableMessage??languageResources.en_US.errorMsg.noScheduleAvailableMessage;
        break;        
      case DataService_Domain_Models_ErrorCodes.AUTHENTICATION_FAILURE:
        message = globalCtx.LangResources.errorMsg.authenticationError??languageResources.en_US.errorMsg.authenticationError;
        break;
      case DataService_Domain_Models_ErrorCodes.AUTHORIZATION_FAILURE:
        message = globalCtx.LangResources.errorMsg.authorizationError??languageResources.en_US.errorMsg.authorizationError;
        break;
      case DataService_Domain_Models_ErrorCodes.SURVEY_ENGINE_LEGACY_MODE_ON:
        message = globalCtx.LangResources.errorMsg.legacyModeErrorMsg??languageResources.en_US.errorMsg.legacyModeErrorMsg;
        break;         
      case DataService_Domain_Models_ErrorCodes.POST_SURVEY_SESSIONS_SCHEDULE_ERROR:
        message = globalCtx.LangResources.errorMsg.panelistScheduleError??languageResources.en_US.errorMsg.panelistScheduleError;
        break; 
      case DataService_Domain_Models_ErrorCodes.POST_SURVEY_SESSIONS_RESCHEDULE_ERROR:
        message = globalCtx.LangResources.errorMsg.panelistReScheduleError??languageResources.en_US.errorMsg.panelistReScheduleError;
        break;                
      default:
        message = globalCtx.LangResources.errorMsg.unExpectedError??languageResources.en_US.errorMsg.unExpectedError;
        break;  
    }
    component = <SurveyError messageHeader={globalCtx.LangResources.errorMsg.header??languageResources.en_US.errorMsg.header} messageTxt={message}/>
  }
  else if (surveytCtx.IsTimeOut) {
    component = <TimeOut messageHeader={globalCtx.LangResources.timeOutMsg.header} messageTxt={globalCtx.LangResources.timeOutMsg.message} />
  }
  else if(surveytCtx.IsComplete)
  {
    let message=""
    switch(recruitCtx.currentState)
    {
      case ScheduleState.POST_SURVEY_RESCHEDULE_CONFIRM:
        message = globalCtx.LangResources.thankYouMsg.postSurveyRescheduleMessage;
        break;
      case ScheduleState.POST_SURVEY_CANCEL:
        message = globalCtx.LangResources.thankYouMsg.postSurveyCancelMessage;
        break;  
    }
    component = <SurveyComplete messageHeader={globalCtx.LangResources.thankYouMsg.header} messageTxt={message}/>
  }
  else if (surveytCtx.IsLoading) {
    component = <LoaderSpinner fullScreen={false}/>;
  }
  else {
    let currentSession: Array<SelectedSession> = surveytCtx.currentPanelistSchedule.session?.map((item: SurveyService_Models_PanelistSessionSchedule, index: number) => {

      let session: SelectedSession = {
        sessionId: item.sessionId!,
        sessionName: item.sessionName!,
        sessionDay: format(new Date(item.beginTime!), 'EEEE, MMMM dd, yyyy'),
        sessionStartTime: String(formatInTimeZone(new Date(item.beginTime!), surveytCtx.panelistTimeZone!, 'h:mm aaa')).toUpperCase(),
        sessionEndTime: String(formatInTimeZone(new Date(item.endTime!), surveytCtx.panelistTimeZone!, 'h:mm aaa')).toUpperCase(),
        isOverFlow: surveytCtx.currentPanelistSchedule.panelistOverAllStatus === "Standby" ? true : false
      }
      if (item.subSessions) {
        let subsession = item.subSessions.map((subsession: SurveyService_Models_PanelistSessionSchedule) => {
          let sub: SelectedSession = {
            sessionId: subsession.sessionId!,
            sessionName: 'SubSession',
            sessionDay: format(new Date(subsession.beginTime!), 'EEEE, MMMM dd, yyyy'),
            sessionStartTime: String(formatInTimeZone(new Date(subsession.beginTime!), surveytCtx.panelistTimeZone!, 'h:mm aaa')).toUpperCase(),
            sessionEndTime: String(formatInTimeZone(new Date(subsession.endTime!), surveytCtx.panelistTimeZone!, 'h:mm aaa')).toUpperCase(),
            isOverFlow: false,
            subSession: []
          };
          return sub;
        });
        session.subSession = subsession
      }

      return session;

    }) ?? [];

    if (recruitCtx.currentState === ScheduleState.POST_SURVEY_CANCEL
      || recruitCtx.currentState === ScheduleState.POST_SURVEY_CONFIRM
      || recruitCtx.currentState === ScheduleState.POST_SURVEY_SCHEDULED) {
      component = <RecruitConfirmation
        id={-1}
        studyName={surveytCtx.currentPanelistSchedule.studyName!}
        selectedSessions={currentSession}
        studyType={surveytCtx.currentPanelistSchedule.studyType!}
        getSubmitSchedule={getSubmitSchedule} 
        confirmEnabled={surveytCtx.currentPanelistSchedule.sessionConfirm!}
        cancelEnabled={surveytCtx.currentPanelistSchedule.sessionCancel!} 
        rescheduleEnabled={surveytCtx.currentPanelistSchedule.sessionReschedule!}
        />
    }
    else if (recruitCtx.currentState === ScheduleState.POST_SURVEY_RESCHEDULE_CONFIRM) {
      component = <RecruitConfirmation
        id={-1}
        studyName={surveytCtx.currentPanelistSchedule.studyName!}
        selectedSessions={recruitCtx.selectedSessions}
        studyType={surveytCtx.currentPanelistSchedule.studyType!}
        getSubmitSchedule={getSubmitSchedule} 
        confirmEnabled={surveytCtx.currentPanelistSchedule.sessionConfirm!}
        cancelEnabled={surveytCtx.currentPanelistSchedule.sessionCancel!} 
        rescheduleEnabled={surveytCtx.currentPanelistSchedule.sessionReschedule!}/>
    }

    else if (recruitCtx.currentState === ScheduleState.POST_SURVEY_RESCHEDULE
      || recruitCtx.currentState === ScheduleState.POST_SURVEY_CANCELLED
      || recruitCtx.currentState === ScheduleState.POST_SURVEY_COMPLETED_DIALOG) 
    {
      if(surveytCtx.AvailableSessions)
      {
        let available = {...surveytCtx.AvailableSessions}
        if(surveytCtx.currentPanelistSchedule.studyType === SurveyEngine_Models_StudyType.CLASSIC)
        {
          
          if(surveytCtx.currentPanelistSchedule.panelistOverAllStatus !== "Cancelled" &&  surveytCtx.currentPanelistSchedule.panelistOverAllStatus !== "CompletedDialog")
          {
            if(surveytCtx.AvailableSessions.sessions && surveytCtx.AvailableSessions.sessions?.length > 0)
              available.sessions = surveytCtx.AvailableSessions.sessions.filter(s => currentSession.findIndex(cs => cs.sessionId === (s as SurveyEngine_Models_Session).id) < 0 )
          }
          
          if(!available.sessions || available.sessions.length <=0)
          {
            component = <SurveyError messageHeader={globalCtx.LangResources.errorMsg.header} messageTxt={globalCtx.LangResources.errorMsg.noScheduleAvailableMessage}/>
          }
          else
          {
            component = <BasicSession
            id={100}
            message={surveytCtx.currentPanelistSchedule.panelistOverAllStatus !== "Cancelled" && surveytCtx.currentPanelistSchedule.panelistOverAllStatus !== "CompletedDialog"?
              globalCtx.LangResources.recruitMsg.rescheduleMsg ?? languageResources.en_US.recruitMsg.rescheduleMsg
              : globalCtx.LangResources.recruitMsg.scheduleMsg?? languageResources.en_US.recruitMsg.scheduleMsg}
            studyName={surveytCtx.currentPanelistSchedule.studyName??""}
            sessions={available}
            panelistTimeZone={surveytCtx.panelistTimeZone}
            isAcquireAvalibility={false}
            postSurvey={true}
          />
          }
        }
        else if(surveytCtx.currentPanelistSchedule.studyType === SurveyEngine_Models_StudyType.SESSION_CLUSTER)
        {
          if(!available.sessions || available.sessions.length <=0)
          {  
              component = <SurveyError messageHeader={globalCtx.LangResources.errorMsg.header} messageTxt={globalCtx.LangResources.errorMsg.noScheduleAvailableMessage}/>
          }
          else
          {
            component = <Cluster
            id={100}
            message={surveytCtx.currentPanelistSchedule.panelistOverAllStatus !== "Cancelled" && surveytCtx.currentPanelistSchedule.panelistOverAllStatus !== "CompletedDialog"?
              globalCtx.LangResources.recruitMsg.rescheduleMsg ?? languageResources.en_US.recruitMsg.rescheduleMsg
              : globalCtx.LangResources.recruitMsg.scheduleMsg?? languageResources.en_US.recruitMsg.scheduleMsg}
            studyName={surveytCtx.currentPanelistSchedule.studyName??""}
            sessions={surveytCtx.AvailableSessions}
            selectedSession={[]}
            panelistTimeZone={surveytCtx.panelistTimeZone}
            postSurvey={true} />
          }
         }
         else if(surveytCtx.currentPanelistSchedule.studyType === SurveyEngine_Models_StudyType.CALENDAR 
          && surveytCtx.AvailableSessions.calendarRecruitUrl && surveytCtx.AvailableSessions.calendarRecruitUrl.length > 0)
          {
            component = <Calendly id={100}
            message={surveytCtx.currentPanelistSchedule.panelistOverAllStatus !== "Cancelled" && surveytCtx.currentPanelistSchedule.panelistOverAllStatus !== "CompletedDialog"?
              globalCtx.LangResources.recruitMsg.rescheduleMsg ?? languageResources.en_US.recruitMsg.rescheduleMsg
              : globalCtx.LangResources.recruitMsg.scheduleMsg?? languageResources.en_US.recruitMsg.scheduleMsg}
            studyName={surveytCtx.currentPanelistSchedule.studyName??""}
            calendarRecruitUrl={surveytCtx.AvailableSessions.calendarRecruitUrl!}
            postSurvey={true}
            getNextQuestionCommand={() => {}}
            getSubmitCalendarSchedule={getSubmitCalendarSchedule}

          />
         }
        }
        else{
          component = <SurveyError messageHeader={globalCtx.LangResources.errorMsg.header} messageTxt={globalCtx.LangResources.errorMsg.noScheduleAvailableMessage}/>
        }
      }
    else
    {
      component = <></>
    }

  }
  return(
    <>
      {(globalCtx.StudyId > 0 || globalCtx.StudyIdentifier !== '') && globalCtx.LangResources === null ? 
        <div className="flex theme-survey-container p-5 md:p-20 flex-col" data-testid="survey-container">
          <LoaderSpinner fullScreen={true}/>
        </div>
        :
        <div className="flex theme-survey-container fade-in p-5 md:p-20 flex-col" data-testid="survey-container">
          {surveytCtx.IsAPIError && !showErrorPage(surveytCtx.currentPanelistSchedule.studyType!,surveytCtx.APIError.errorCode!) && !surveytCtx.IsComplete && !surveytCtx.IsLoading &&
            <Error className="theme-validator-error-text font-semibold" direction='start' id={"APIError"}>
            <FontAwesomeIcon icon={faCircleExclamation} className="theme-icon-spacer" />
            {surveytCtx.APIError.errorCode === DataService_Domain_Models_ErrorCodes.SESSION_IS_FULL ? globalCtx.LangResources.recruitMsg.submitScheduleErrorMsg:globalCtx.LangResources.errorMsg.apiErrorMessage}
            </Error>
          }
          {!surveytCtx.IsAPIError && !surveytCtx.IsComplete && !surveytCtx.IsLoading &&
            <Timer
            studyId={globalCtx.StudyId}
            panelistId={globalCtx.PanelistId}
            postSurvey={true}
            refreshToken={getRefreshToken}
            abandonSurvey={getAbandonSurvey}
            timeOutMS={180_000}
            />
          }
          {component}
        </div>
      }
    </>
    
  )
}
